// libraries.
import { robotoRegular } from '@habitech/shared';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Form, InputGroup } from 'react-bootstrap';

// selectors.
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';

// hooks.
import { useGetLeadDetailInfoQuery } from '@domains/lead-detail';

// slices.
import {
  setSelectedCoordinates,
  setLoadingCoordinates,
  setDefaultState,
} from '../store/slices/georeferencing-slice';

export const SearchNid = () => {
  const dispatch = useDispatch();
  const country = useSelector(getCountry);
  const [inputValue, setInputValue] = useState('');
  const [searchNid, setSearchNid] = useState<string>('');

  const {
    data: leadDetail,
    isLoading,
    isFetching,
  } = useGetLeadDetailInfoQuery(
    { country, nid: searchNid },
    { skip: !searchNid }
  );

  useEffect(() => {
    dispatch(setLoadingCoordinates(isLoading || isFetching));
  }, [isLoading, isFetching, dispatch]);

  useEffect(() => {
    if (leadDetail?.location?.coordinates) {
      const coords = leadDetail.location.coordinates;

      const [lat, lng] = coords;

      if (
        typeof lat === 'number' &&
        typeof lng === 'number' &&
        !isNaN(lat) &&
        !isNaN(lng) &&
        lat >= -90 &&
        lat <= 90 &&
        lng >= -180 &&
        lng <= 180
      ) {
        dispatch(
          setSelectedCoordinates({
            coordinates: { lat, lng },
            nid: searchNid,
          })
        );
      }
    }
  }, [leadDetail, searchNid, dispatch]);

  const handleSearch = () => {
    const nid = inputValue.trim();
    if (nid) {
      // Limpiar estado antes de buscar un nuevo NID
      dispatch(setDefaultState());
      setSearchNid(nid);
      setInputValue('');
    }
  };

  return (
    <div className="d-flex flex-column gap-4">
      <InputGroup>
        <Form.Control
          placeholder="Buscar NID"
          aria-label="Buscar NID"
          aria-describedby="search-nid-button"
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          style={{ fontFamily: robotoRegular, fontSize: '14px' }}
        />
        <Button
          variant="outline-secondary"
          id="search-nid-button"
          onClick={handleSearch}
          style={{ fontFamily: robotoRegular, fontSize: '14px' }}
        >
          Buscar
        </Button>
      </InputGroup>
    </div>
  );
};
